module.exports = __webpack_public_path__ + "058c259ed0b67d12ed8996e6f73254fd.fbx";